import { render, staticRenderFns } from "./seeReviewModel.vue?vue&type=template&id=ef87a610"
import script from "./seeReviewModel.vue?vue&type=script&lang=js"
export * from "./seeReviewModel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ef87a610')) {
      api.createRecord('ef87a610', component.options)
    } else {
      api.reload('ef87a610', component.options)
    }
    module.hot.accept("./seeReviewModel.vue?vue&type=template&id=ef87a610", function () {
      api.rerender('ef87a610', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/examine/reviewManage/seeReviewModel.vue"
export default component.exports